export default __webpack_public_path__ + "static/media/personalBanner.45797435.jpg";